import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ===== PREVENT ZOOM =====
// Prevent Ctrl+Scroll zoom
document.addEventListener('wheel', (e) => {
  if (e.ctrlKey) {
    e.preventDefault();
    return false;
  }
}, { passive: false });

// Prevent Ctrl+Plus/Minus zoom
document.addEventListener('keydown', (e) => {
  if (e.ctrlKey && (e.key === '+' || e.key === '-' || e.key === '=')) {
    e.preventDefault();
    return false;
  }
}, { passive: false });

// Prevent pinch zoom on touch devices
let lastTouchDistance = 0;
document.addEventListener('touchstart', (e) => {
  if (e.touches.length === 2) {
    lastTouchDistance = Math.hypot(
      e.touches[0].pageX - e.touches[1].pageX,
      e.touches[0].pageY - e.touches[1].pageY
    );
  }
}, { passive: false });

document.addEventListener('touchmove', (e) => {
  if (e.touches.length === 2) {
    e.preventDefault();
    const currentDistance = Math.hypot(
      e.touches[0].pageX - e.touches[1].pageX,
      e.touches[0].pageY - e.touches[1].pageY
    );
    
    if (Math.abs(currentDistance - lastTouchDistance) > 10) {
      e.preventDefault();
    }
  }
}, { passive: false });